import { en } from "./en";
import { fr } from "./fr";

const localization = {
  en,
  fr,
};

export default localization;
